/**
 * App.js
 * Description: Main app component
 */

import { useReducer } from "react";

import Editor from "./Editor";
import Output from "./Output";

import { ChakraProvider, Flex, Box } from "@chakra-ui/react";

import { defaultState, Provider, reducer } from "../context/GlobalState";

const App = () => {
  // useState -> returns a state and a function that changes it, everytime state changes, a component and its child re-renders

  const [state, dispatch] = useReducer(reducer, defaultState);

  // props -> short for property, a data passed to a component
  // props pattern: <Component props_name={props_data} />

  return (
    // Provider -> provides global state to all of the components
    <ChakraProvider>
      <Provider value={{ state, dispatch }}>
        <Flex minH="100vh" align="stretch">
          <Box flex={1} borderRight="1px" borderColor="white">
            <Editor />
          </Box>
          <Box flex={1}>
            <Output />
          </Box>
        </Flex>
      </Provider>
    </ChakraProvider>
  );
};

export default App;
